var _path, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgModalTorqueMeterIconCarbarn(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_410_12047)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_410_12047",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 1.90735e-06H24V24H0V1.90735e-06Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_410_12047)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.28486 19.9065C0.509215 20.6823 0.509215 21.9394 1.28486 22.7152C2.06026 23.4908 3.31829 23.4908 4.09375 22.7152L11.6648 15.1424L8.85629 12.3334L1.28486 19.9065Z",
    stroke: "#061D33",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.6425 17.1648L6.83398 14.3557",
    stroke: "#061D33",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.7878 4.9163L19.0775 3.20536L16.7413 3.83161L16.1152 6.16875L17.8255 7.87964L20.1618 7.25344L20.7878 4.9163Z",
    stroke: "#061D33",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.8775 8.96935C23.7857 7.06051 23.7692 3.95546 21.8283 2.06715C19.9088 0.199649 16.8028 0.257681 14.9512 2.19249C14.1996 2.97788 13.7634 3.95391 13.6425 4.96065C13.4715 6.3842 12.8042 7.70209 11.7908 8.7159L11.2773 9.22951L14.7662 12.7197L15.303 12.1829C16.3222 11.1632 17.6572 10.5347 19.0864 10.3471C20.1071 10.2131 21.0933 9.75385 21.8775 8.96935Z",
    stroke: "#061D33",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.1416 14.6191L9.37891 12.8558L12.1407 10.0929L13.9034 11.8563L11.1416 14.6191Z",
    stroke: "#061D33",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_410_12047"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgModalTorqueMeterIconCarbarn);
export default __webpack_public_path__ + "static/media/modal-torque-meter-icon-carbarn.53008ea551cdfca68c5ae5ab80a9de06.svg";
export { ForwardRef as ReactComponent };